import React, { useEffect, useState, useContext } from 'react'
import { HeadActions, HeadCon } from './styles'
import { LeagueContext, SeasonContext } from '../../Context'
import { PageHeader } from '../../Components/Headers'
import { PageContainerMain, Box } from '../../Components/Layout'
import { EventUpdate } from './EventUpdate/EventUpdate'
import { mapEventWeeks, getWeekendRange } from '../../Utils'
import { PLL_IMAGES, PLL_LINKS } from '../../Config/config'
import { EVENTS_YEAR } from '../../Config/League/league.config'
import { logEvent } from '../../Utils'
import { EventGQL, EventHubData, fetchEventHubInfo } from '../../Api'
import { Loading } from '../Loading'
import { HubTabs } from './HubTabs/HubTabs'
import { colors } from '../../Components/consts'
import { Lk } from '../../Components/Links/Lk'

const EventHub: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { events } = useContext(LeagueContext)!
  const { incompleteMarkets } = useContext(SeasonContext)!
  const [weekendEvents, setWeekendEvents] = useState<EventGQL[]>([])
  const [gameInfo, setGameInfo] = useState<EventHubData | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    if (!events) {
      return
    } else {
      getEvents()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [events, isLoading])

  const getEvents = async () => {
    const weekRes = events.find((ev) => ev.eventStatus < 2)
    if (!weekRes) return
    const evs = mapEventWeeks({ week: weekRes.week, events: events })

    const yr = evs.length > 1 ? evs[0].year : EVENTS_YEAR
    await fetchGameInfo(yr, parseInt(weekRes.week))
    setWeekendEvents(evs)
  }
  const fetchGameInfo = async (year: number, week: number) => {
    const gmInfo = await fetchEventHubInfo(year, week)
    if (!gmInfo) {
      setIsLoading(false)
      return
    }
    setGameInfo(gmInfo)
    setIsLoading(false)
  }

  if (isLoading) {
    return (
      <PageContainerMain>
        <PageHeader
          banner={null}
          img={PLL_IMAGES.gamedayHub}
          tags={['Gameday Hub', 'Ticketmaster']}
        />
        <Loading />
      </PageContainerMain>
    )
  }

  return (
    <PageContainerMain>
      <PageHeader img={PLL_IMAGES.gamedayHub} tags={['Gameday Hub', 'Ticketmaster']} />
      {gameInfo && gameInfo.showUpdate && (
        <EventUpdate message={gameInfo?.updateMessage} />
      )}
      {weekendEvents && weekendEvents?.length > 0 && (
        <Box sideMargins={0} boxColor={colors.darkBackground}>
          <HeadCon>
            <div className="weekendHeaderCon">
              <h1>{weekendEvents[0].location} Weekend</h1>
              <p>{getWeekendRange(weekendEvents, incompleteMarkets)}</p>
            </div>
            <div>
              <Lk link={`${PLL_LINKS.myTickets}`} alt='Access Tickets'>
                <HeadActions
                  onClick={() =>
                    logEvent('access_tickets_click', {
                      section: 'Gameday Hub',
                      week: weekendEvents[0].week,
                      market: weekendEvents[0].location,
                    })
                  }
                >
                  Access Tickets
                </HeadActions>
              </Lk>
            </div>
          </HeadCon>
          {gameInfo && <HubTabs hubInfo={gameInfo} events={weekendEvents} />}
        </Box>
      )}
    </PageContainerMain>
  )
}

export default EventHub
